import { injectable } from 'inversify';
import type { TrackLabel } from '../../../types/common';

export interface PendingClosureProducer {
  label: TrackLabel;
  producerId: string;
}

@injectable()
class PendingClosureProducerStorage {
  readonly #pending = new Map<TrackLabel, PendingClosureProducer>();

  set(label: TrackLabel, producerId: string): void {
    this.#pending.set(label, {
      label,
      producerId,
    });
  }

  get(label: TrackLabel): PendingClosureProducer | undefined {
    return this.#pending.get(label);
  }

  has(label: TrackLabel): boolean {
    return this.#pending.has(label);
  }

  delete(label: TrackLabel): void {
    this.#pending.delete(label);
  }

  entries(): PendingClosureProducer[] {
    return Array.from(this.#pending.values());
  }
}

export default PendingClosureProducerStorage;
